import type { PreviewContact } from '../types/import';
import { supabase } from '../lib/supabase';

export async function findDuplicates(contacts: PreviewContact[]): Promise<Set<string>> {
  const duplicates = new Set<string>();

  // Check for duplicates within the import set
  const seen = new Set<string>();
  contacts.forEach(contact => {
    const key = `${contact.first_name}-${contact.last_name}-${contact.personal_email || contact.work_email}`;
    if (seen.has(key)) {
      duplicates.add(key);
    }
    seen.add(key);
  });

  // Check for duplicates in the database
  const emails = contacts
    .map(c => [c.personal_email, c.work_email])
    .flat()
    .filter(Boolean) as string[];

  if (emails.length) {
    const { data: existingContacts } = await supabase
      .from('nrm_contacts')
      .select('personal_email, work_email, first_name, last_name')
      .or(`personal_email.in.(${emails}),work_email.in.(${emails})`);

    if (existingContacts) {
      existingContacts.forEach(existing => {
        contacts.forEach(contact => {
          if (
            (contact.personal_email && (contact.personal_email === existing.personal_email || contact.personal_email === existing.work_email)) ||
            (contact.work_email && (contact.work_email === existing.personal_email || contact.work_email === existing.work_email))
          ) {
            const key = `${contact.first_name}-${contact.last_name}-${contact.personal_email || contact.work_email}`;
            duplicates.add(key);
          }
        });
      });
    }
  }

  return duplicates;
}